var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RBusinessHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8,15 H40 V39 H8 Z",
    fill: "#7C1CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14,9 H34 L38,15 H10 Z",
    fill: "#FFD000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13,20 H21 V28 H13 Z M27,20 H35 V28 H27 Z M19,31 H29 V39 H19 Z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37,7 A5,5 0,1 0,37,17 A5,5 0,1 0,37,7",
    fill: "#00D4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RBusinessHub);
export default __webpack_public_path__ + "static/media/p4r_business_hub.0d6e63775a9b49efd13c59fbe9e44f5a.svg";
export { ForwardRef as ReactComponent };